import * as React from 'react';

import {Username, Password} from './fields';

type Props = {
    username: string;
    password: string;
    onChangeUsername: (arg1: string) => void;
    onChangePassword: (arg1: string) => void;
    onEnter: () => void;
};

export function SmtpFormAuthenticationFields(props: Props) {
    return (
        <React.Fragment>
            <Username
                value={props.username}
                onChange={props.onChangeUsername}
                onEnter={props.onEnter}
            />
            <Password
                value={props.password}
                onChange={props.onChangePassword}
                onEnter={props.onEnter}
            />
        </React.Fragment>
    );
}
